import vdnSettingsApi from '@api/vdn-settings';

import {
  vdnSettingsRequest,
  vdnSettingsFailure,
  getVdnSettingsSuccess,
  updateVdnSettingsSuccess,
  getVdnVersionsSuccess
} from '@store/reducers/vdnSettings';
import { errorAlert, successAlert } from '@store/reducers/alerts';


function updateVdnSettings(agentId, vdnMapJson, versionName, versionDescription, onSuccess) {
  return dispatch => {
    vdnSettingsApi
      .updateVdnMap(agentId, vdnMapJson, versionName, versionDescription)
      .then(response => {
        dispatch(updateVdnSettingsSuccess(response.data));
        dispatch(successAlert('VDN version created'));
        dispatch(getVdnVersions(agentId));
        if (onSuccess && response.data && response.data._id) {
          onSuccess(response.data._id);
        }
      })
      .catch(error => {
        dispatch(errorAlert((error.response && error.response.data) || error.message));
      });
  };
}

function getVdnVersions(agentId) {
  return dispatch => {
    dispatch(vdnSettingsRequest());
    vdnSettingsApi
      .getVdnMapVersions(agentId)
      .then(response => {
        const versions = (response.data && response.data.versions) || [];
        dispatch(getVdnVersionsSuccess(versions));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function loadVdnVersion(agentId, versionId) {
  return dispatch => {
    dispatch(vdnSettingsRequest());
    vdnSettingsApi
      .getVdnMapVersionById(agentId, versionId)
      .then(response => {
        const data = response.data || {};
        dispatch(getVdnSettingsSuccess(data));
      })
      .catch(error => {
        handleError(dispatch, error);
      });
  };
}

function handleError(dispatch, error) {
  dispatch(vdnSettingsFailure(error.message));
  dispatch(errorAlert((error.response && error.response.data) || error.message));
}

export default {
  updateVdnSettings,
  getVdnVersions,
  loadVdnVersion
};
